import React from 'react';
import { lang } from '@umu/ukit-lang';
import { ResourceStatus } from '@umu/umu-types';
import { $location } from '@umu/umu-dom';
import { Iconfont, Button } from '@umu/umu-design';
export function TranscodingStatus(props: { transStatus?: ResourceStatus }) {
    const { transStatus } = props;
    const transText: Record<string, string> = {
        __INIT__: '',
        wait_transcoding: lang('文档处理中，请稍后查看'),
        transcoding_fail: lang('文档处理失败'),
    };
    const label = transText?.[(transStatus as keyof typeof transText) || '__INIT__'] || '';
    const isReload = transStatus === ResourceStatus.WAIT_TRANSCODING;
    if (!label && !isReload) {
        return null;
    }
    const reload = () => {
        $location.reload();
    };

    return (
        <div className="pdf-render-trans-info flex-column flex-center">
            <Iconfont type="Txt" className="trans-icon m-b-12" />
            {label && <div className="pdf-render-trans-info-label">{label}</div>}
            {!isReload && (
                <Button type="text" isOnlyChildren className="flex-center trans-button" onClick={reload}>
                    <Iconfont type="RefreshHalfCircle" className="refresh-icon" />
                    {lang('刷新')}
                </Button>
            )}
        </div>
    );
}
